import { render, staticRenderFns } from "./BroadcastIndex.vue?vue&type=template&id=31a5d9aa&scoped=true&"
import script from "./BroadcastIndex.vue?vue&type=script&lang=js&"
export * from "./BroadcastIndex.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastIndex.vue?vue&type=style&index=0&id=31a5d9aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a5d9aa",
  null
  
)

export default component.exports